import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark" }
const _hoisted_2 = {
  class: "collapse navbar-collapse",
  id: "WorkspaceNavigation"
}
const _hoisted_3 = { class: "navbar-nav mr-auto" }
const _hoisted_4 = { class: "nav-item dropdown" }
const _hoisted_5 = {
  class: "dropdown-menu",
  style: {"max-height":"400px","overflow-y":"auto"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "dropdown-header" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-link" }
const _hoisted_11 = { class: "navbar-nav" }
const _hoisted_12 = { class: "nav-item dropdown" }
const _hoisted_13 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "dropdown-item"
}
const _hoisted_16 = { class: "dropdown-item" }
const _hoisted_17 = { class: "dropdown-item" }

import { computed } from 'vue'
    import { strCompareLowerCase } from '@common/Common'
    import type { UserSessionDetailsReadModel, WorkspaceItem } from '@Organizations/Users/readmodels'
    import { useCurrentUserQueryV1 } from '@Organizations/Users/queries-vue-composables'

    // props
    
export default /*@__PURE__*/_defineComponent({
  __name: 'WorkspaceNavigation',
  props: {
    workspaceId: {},
    workspaceName: {}
  },
  setup(__props: any) {

    const props = __props

    // query (replaces UsersQueries mixin)
    const {
        runCurrentUserQueryV1,
        modelCurrentUserQueryV1: user
    } = useCurrentUserQueryV1(false, false, false)

    // computed (replaces getter workspacesView)
    const workspacesView = computed(() =>
    {
        if (!user.value?.Workspaces?.length)
        {
            return []
        }

        const workspaceGroups = new Map<string, WorkspaceItem[]>()

        for (const workspace of user.value.Workspaces)
        {
            const orgName = workspace.OrganizationName

            if (!workspaceGroups.has(orgName))
            {
                workspaceGroups.set(orgName, [])
            }

            workspaceGroups.get(orgName)!.push(workspace)
        }

        return Array.from(workspaceGroups)
            .map(([org, workspaces]) => ({
                OrganizationUnitName: org,
                Workspaces: workspaces.sort((a, b) =>
                    strCompareLowerCase(a.Name, b.Name)
                ),
            }))
            .sort((a, b) =>
                strCompareLowerCase(a.OrganizationUnitName, b.OrganizationUnitName)
            )
    })

    // method (unchanged behavior)
    function loadUser()
    {
        if (user.value == null)
        {
            runCurrentUserQueryV1()
        }
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#WorkspaceNavigation",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }, [
      _createElementVNode("span", { class: "navbar-toggler-icon" })
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: "navbar-brand dropdown-toggle text-light",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loadUser())),
            id: "navbarDropdown",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, [
            _createElementVNode("span", null, _toDisplayString(__props.workspaceName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_unref(user))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspacesView.value, (g) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("h6", _hoisted_7, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", {
                          class: "fa fa-home",
                          "aria-hidden": "true"
                        }, null, -1 /* CACHED */)),
                        _createTextVNode(" " + _toDisplayString(g.OrganizationUnitName), 1 /* TEXT */)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.Workspaces, (w) => {
                        return _withDirectives((_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item",
                          key: w.Id
                        }, [
                          _createElementVNode("strong", null, _toDisplayString(w.Name), 1 /* TEXT */)
                        ])), [
                          [_directive_sanitizedHref, `/#/dashboard/${w.Id}`]
                        ])
                      }), 128 /* KEYED_FRAGMENT */)),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */))
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, " Loading "))
          ])
        ]),
        _createElementVNode("li", _hoisted_9, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Scales", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/scales/${__props.workspaceId}`]
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_11, [
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("a", {
            onClick: loadUser,
            class: "nav-link dropdown-toggle",
            id: "navbarDropdownMenuLink",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", null, "Account", -1 /* CACHED */)
          ]))]),
          _createElementVNode("div", _hoisted_13, [
            (_unref(user))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_unref(user).IsGlobalAdmin || _unref(user).IsOrganizationAdmin)
                    ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, [...(_cache[5] || (_cache[5] = [
                        _createTextVNode(" Go to admin ", -1 /* CACHED */)
                      ]))])), [
                        [_directive_sanitizedHref, `/#/admin/organizations/dashboard/${_unref(user).OrganizationUnitId}`]
                      ])
                    : _createCommentVNode("v-if", true),
                  _cache[8] || (_cache[8] = _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "/#/organizations/users/dashboard"
                  }, "My dashboard", -1 /* CACHED */)),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Manage your account", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/organizations/users/account`]
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_17, [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Sign out", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/organizations/sessions/close`]
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})